export const supportedCurrencies = [
  { value: "SEK", label: "SEK" },
  { value: "EUR", label: "EUR" },
];
